import constantsFactory from '@/utils/constants';
import {retryIfFails} from '@/utils/helpers/api';
import axios from 'axios';

const {API} = constantsFactory();

export const loadArtistPageInfo = (
  artistSlug: string,
  onSuccessCallbacks: ((data?: any) => void)[] = [],
  onErrorCallbacks: ((error: any) => void)[] = [],
) => ({
  types: ['_', '_', '_'],
  callAPI: () =>
    retryIfFails(
      () =>
        axios.get(`${process.env.HOST}${API.ARTIST}${artistSlug}/`, {
          headers: {
            Accept: 'application/json',
          },
          timeout: API.TIMEOUT,
        }),
      3,
    ),
  onSuccess: onSuccessCallbacks,
  onError: onErrorCallbacks,
});
